import request from "@/utils/request.js"

// 组织会员申请记录列表
export const listStoreMemberApplications = (pageData, formData) => {
    return request.post(`/storeMemberApplications/${pageData.page}/${pageData.pageSize}`, formData)
}

// 修改组织会员申请记录-状态
export const editStoreMemberApplications = (updateData) => {
    return request.put(`/storeMemberApplications/state/${updateData.id}/${updateData.state}`)
}

// 修改组织会员申请记录-状态新
export const editStoreMemberApplicationsNew = (updateData) => {
    return request.put(`/storeMemberApplications/state`, updateData)
}
